import classNames from "classnames";
import React from "react";
import { Link, useLocation } from "react-router-dom";
import Image from "../../elements/Image";

const Logo = ({ header = false, className, ...props }) => {
  const classes = classNames("brand", className);
  const { pathname } = useLocation();

  return (
    <div {...props} className={classes}>
      <h1 style={{ margin: "auto", marginRight: "32px" }}>
        <Link to="/">
          <Image
            src={require(`./../../../assets/images/${
              (pathname === "/onestack-data" ||
                pathname === "/onestack-data/") &&
              header
                ? "dzip-logo-black"
                : "dzip-logo-white"
            }.svg`)}
            alt="Open"
            width={150}
            height={150}
          />
        </Link>
      </h1>
    </div>
  );
};

export default Logo;
